let scrollButtons = document.querySelectorAll('.js-scroll-button');

if (typeof scrollButtons != "undefined" && scrollButtons != null) {
    scrollDown()
}

function scrollDown() {
    scrollButtons.forEach((button) => {
        button.addEventListener('click', () => {
            if (ajaxOpen) {
                gsap.to($ajaxOverlay, {duration: 0.6, ease: "power4.easeInOut", scrollTo: window.innerHeight - header.offsetHeight});
            } else {
                gsap.to(window, {duration: 0.6, ease: "power4.easeInOut", scrollTo: window.innerHeight - header.offsetHeight});
            }
        })
    })
}